import '../styles/style.scss'
import '../styles/semantic.js'
import '../styles/semantic.scss'

import Vue from 'vue'

import createRouter from './router/router'
import store from './store/store'
import App from './App.vue'

import firebaseInit from './cloud/firebaseInit'
import resolve from './router/resolve'

(async function main() {
  await firebaseInit();

  let data = await resolve();
  let router = await createRouter(data.area);

  new Vue({
    el: '#app',
    router,
    store: store(data, router),
    render: h => h(App)
  });
})();


// WEBPACK FOOTER //
// ./src/main.js